module.exports = __webpack_public_path__ + "img/fctimg02@2x_wps.44bb3831.png";